
import { Vue, Prop, Component } from "vue-property-decorator";
import DepartmentAssignment from './department-assignment.model';

@Component
export default class DepartmentStaff extends Vue {
    
    @Prop() staffId!: number;
    @Prop() firstName!: string;
    @Prop() lastName!: string;
    @Prop() skill!: string;
    @Prop() charge!: boolean;
    @Prop() assignments!: DepartmentAssignment[];
}